import styled from "styled-components";

import { LARGE_SCREEN } from "../constants/screenSizes";
import { baseTextStyles } from "./shared/styled";
import PrimaryLarge, { H1 } from "./PrimaryLarge";
import PrimaryMedium, { H2 } from "./PrimaryMedium";
import PrimarySmall, { H3 } from "./PrimarySmall";
import SecondaryLarge, { H4 } from "./SecondaryLarge";
import SecondaryMedium, { H5 } from "./SecondaryMedium";
import SecondarySmall, { H6 } from "./SecondarySmall";

export const Body = styled.p`
  ${baseTextStyles}
  font-size: 14px;
  line-height: 22px;

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const BodyLongForm = styled.p`
  ${baseTextStyles}
  font-size: 20px;
  line-height: 36px;

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    font-size: 18px;
  }
`;

export const Caps = styled.p`
  ${baseTextStyles}
  font-size: 12px;
  font-weight: 700;
  line-height: 15px;
  text-transform: uppercase;
`;

export const Caption = styled.p`
  ${baseTextStyles}
  font-size: 12px;
  line-height: 16px;
`;

export {
  PrimaryLarge,
  H1,
  PrimaryMedium,
  H2,
  PrimarySmall,
  H3,
  SecondaryLarge,
  H4,
  SecondaryMedium,
  H5,
  SecondarySmall,
  H6
};
export { Body as P };
